export const ru = {
    'banners-limit-in-campaign': 'В кампанию может быть добавлено не более {limit} объявлений.',
    error: 'Произошла ошибка',
    'no-campaign-found': 'Кампании не найдены',
    'search-by-campaign': 'Поиск по кампаниям'
};
